module.exports = __webpack_public_path__ + "img/banner-1.90c3a609.jpg";